import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4d6fb9e4&scoped=true&"
var script = {}
function injectStyles (context) {
  
  var style0 = require("./Loader.vue?vue&type=style&index=0&id=4d6fb9e4&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4d6fb9e4",
  null
  ,true
)

export default component.exports